import {
  amazonWebServices2Logo,
  apolloLogo,
  dockerLogo,
  gremlinNeptuneLogo,
  kubernetesLogo,
  kublrLogo,
  nodejsLogo,
  postgresqlLogo,
  reactLogo,
  solidityLogo,
  terraformLogo,
} from 'Assets/_Legacy/Technologies'

export const STACK_CARDS = [
  { header: 'React.js', caption: 'Front-end', image: reactLogo },
  { header: 'React Native', caption: 'Mobile', image: reactLogo },
  { header: 'Node.js', caption: 'Back-end & API', image: nodejsLogo },
  { header: 'PostgreSQL', caption: 'Database', image: postgresqlLogo },
  {
    header: 'Gremlin & Neptune',
    caption: 'Graph Database',
    image: gremlinNeptuneLogo,
  },
  {
    header: 'Apollo/GraphQL',
    caption: 'Communication Protocol',
    image: apolloLogo,
  },
  { header: 'Solidity', caption: 'Blockchain', image: solidityLogo },
  {
    header: 'Amazon Web Services',
    caption: 'Hosting & DevOps solution',
    image: amazonWebServices2Logo,
  },
  { header: 'Docker', caption: 'Containers', image: dockerLogo },
  {
    header: 'Kubernetes',
    caption: 'Orchestration for enterprise apps',
    image: kubernetesLogo,
  },
  {
    header: 'Kublr',
    caption: 'Orchestration for enterprise apps',
    image: kublrLogo,
  },
  { header: 'Terraform', caption: 'Infrastructure', image: terraformLogo },
]
